var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "warp" },
    [
      _c(
        "el-form",
        { attrs: { "label-width": "auto" } },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-descriptions",
                { attrs: { colon: false, column: 3, direction: "vertical" } },
                [
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("newOrder.SenderName") } },
                    [
                      _c("encryption-field", {
                        attrs: {
                          "field-name": "senderName",
                          "encrypted-value": _vm.senderInfo.senderName,
                          label: _vm.$t("newOrder.SenderName"),
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("newOrder.SenderCompany") } },
                    [
                      _c("encryption-field", {
                        attrs: {
                          "field-name": "senderCompany",
                          "encrypted-value": _vm.senderInfo.senderCompany,
                          label: _vm.$t("newOrder.SenderCompany"),
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("newOrder.senderPhone") } },
                    [
                      _c("encryption-field", {
                        attrs: {
                          "field-name": "senderMobile",
                          "encrypted-value": _vm.senderInfo.senderMobile,
                          label: _vm.$t("newOrder.senderPhone"),
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("newOrder.Street1") } },
                    [
                      _c("div", [
                        _vm._v(_vm._s(_vm.senderInfo.senderStreet || "--")),
                      ]),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("newOrder.SenderNumber") } },
                    [
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm.senderInfo.senderHouseNumber || "--")
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("newOrder.SenderDistrict") } },
                    [
                      _c("div", [
                        _vm._v(_vm._s(_vm.senderInfo.senderArea || "--")),
                      ]),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("newOrder.SenderCity") } },
                    [
                      _c("div", [
                        _vm._v(_vm._s(_vm.senderInfo.senderCity || "--")),
                      ]),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("newOrder.SenderState") } },
                    [
                      _c("div", [
                        _vm._v(_vm._s(_vm.senderInfo.senderState || "--")),
                      ]),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("newOrder.SenderZipCode") } },
                    [
                      _c("div", [
                        _vm._v(_vm._s(_vm.senderInfo.senderZipcode || "--")),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-descriptions",
                { attrs: { colon: false, column: 1, direction: "vertical" } },
                [
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        label: _vm.$t("GlobalSetObj.sendderComplement"),
                      },
                    },
                    [
                      _c("encryption-field", {
                        attrs: {
                          "field-name": "senderComplement",
                          "encrypted-value": _vm.senderInfo.senderComplement,
                          label: _vm.$t("GlobalSetObj.sendderComplement"),
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-descriptions",
                { attrs: { colon: false, column: 3, direction: "vertical" } },
                [
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("newOrder.SenderCPFCNPJ") } },
                    [
                      _c("encryption-field", {
                        attrs: {
                          "field-name": "senderTax",
                          "encrypted-value": _vm.senderInfo.senderTax,
                          label: _vm.$t("newOrder.SenderCPFCNPJ"),
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "GlobalSetObj.NationalRegistrationNumber"
                        ),
                      },
                    },
                    [
                      _c("div", [
                        _vm._v(_vm._s(_vm.senderInfo.senderIeNumber || "--")),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-descriptions",
                { attrs: { colon: false, column: 1, direction: "vertical" } },
                [
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("newOrder.SendingAddress") } },
                    [
                      _c("encryption-field", {
                        attrs: {
                          "field-name": "senderAddress",
                          "encrypted-value": _vm.senderInfo.senderAddress,
                          label: _vm.$t("newOrder.SendingAddress"),
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-descriptions",
                { attrs: { colon: false, column: 3, direction: "vertical" } },
                [
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("newOrder.SenderPhone") } },
                    [
                      _c("encryption-field", {
                        attrs: {
                          "field-name": "senderPhone",
                          "encrypted-value": _vm.senderInfo.senderPhone,
                          label: _vm.$t("newOrder.SenderPhone"),
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("newOrder.SenderEmail") } },
                    [
                      _c("encryption-field", {
                        attrs: {
                          "field-name": "senderMail",
                          "encrypted-value": _vm.senderInfo.senderMail,
                          label: _vm.$t("newOrder.SenderEmail"),
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }